import { render } from "./InputWithButton.vue?vue&type=template&id=32e44f12"
import script from "./InputWithButton.vue?vue&type=script&lang=ts"
export * from "./InputWithButton.vue?vue&type=script&lang=ts"
script.render = render

export default script